/* eslint-disable no-nested-ternary */
/* eslint-disable radix */
/* eslint-disable prettier/prettier */
/* eslint-disable no-param-reassign */
/* eslint-disable react/no-string-refs */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/extensions */
/* eslint-disable react/jsx-curly-brace-presence */
import React, { useState, useCallback } from "react";
import styled, { css } from "styled-components";
import { useTranslation } from 'react-i18next';
import Grid from "@material-ui/core/Grid";
import debounce from "lodash.debounce";
import update from "immutability-helper";
import axios from "axios";
import Cookies from "js-cookie";
import ReactPlaceholder from "react-placeholder";
import {
  TextBlock,
  MediaBlock,
  TextRow,
  RectShape,
  RoundShape,
  Text,
} from "react-placeholder/lib/placeholders";
import { RedX, V } from "../../Constants/assets";
import "react-placeholder/lib/reactPlaceholder.css";

const ColumnContainer = styled.div`
  margin-top: 10px; 
  padding-left: 10px; /* Adjust the value as needed */
`;


const Label = styled.div`
  &:nth-child(1) {
    width: 30%;
  }

  &:nth-child(2) {
    width: 20%;
  }

  &:nth-child(3) {
    width: 30%;
  }
  &:nth-child(4) {
    width: 20%;
  }
`;


const TitleLabel = styled.div`
  width: 100%;
  font-weight: bold;
`;

let ColumnDiv = styled.div`
  display: inline-block
  height: min-content;
  border-bottom: 2px solid grey;
`;
const ProjectCanceledStamp = styled.div`
  color: red;
  font-size: 40px;
  position: relative;
  z-index: 5;
  transform: rotate(-28deg);
  width: max-content;
  left: 65%;
  top: -175px;
  height: max-content;
`

export default function GameSummaryLabels({
  newData,
  toggleSummeryPlaceHolder,
  completion,
  projectCanceled,
  playerQuit,
  gameStartDateTime,
}) {
  const { t } = useTranslation();

  const trueValue = true;
  const falseValue = false;

  // if (projectCanceled || completion < 67 || toggleSummeryPlaceHolder) {
  if (toggleSummeryPlaceHolder) {
    ColumnDiv = styled.div`
      display: flex;
      align-items: center;
      height: min-content;
      border-bottom: 1px solid black;
    `;
  }



  const summaryReport = newData;

  const gameDurationDivideToPlanDuration = () => {
    const secondsGame = parseInt(
      summaryReport.gameTimerLocal
        ? summaryReport.gameTimerLocal
        : summaryReport.gameTimerDB
    );
    const secondsPlan = parseInt(
      summaryReport.totalTimeSpentOPlanning.slice(6)
    );

    const minutesGame =
      parseInt(
        (summaryReport.gameTimerLocal
          ? summaryReport.gameTimerLocal
          : summaryReport.gameTimerDB
        ).slice(3, 5)
      ) * 60;

    const minutesPlan = parseInt(summaryReport.totalTimeSpentOPlanning.slice(3, 5)) * 60;

    const hoursGame =
      parseInt(
        summaryReport.gameTimerLocal
          ? summaryReport.gameTimerLocal
          : summaryReport.gameTimerDB.slice(0, 2)
      ) * 3600;

    const hoursPlan = parseInt(summaryReport.totalTimeSpentOPlanning.slice(0, 2)) * 3600;

    const totalGameTimeInSeconds = secondsGame + minutesGame + hoursGame;
    const totalPlanTimeInSeconds = secondsPlan + minutesPlan + hoursPlan;

    const result = Math.round(
      (totalPlanTimeInSeconds / totalGameTimeInSeconds) * 100
    );
    // console.log(`Game Log info: seconds:${secondsGame} minutes:${minutesGame} hours:${hoursGame}`)
    return result;
  };
  const date = new Date(summaryReport.startGameTime);


  return (
    <>
      <ColumnDiv>
        <ColumnContainer style={{ display: "flex", width: "100%" }}>
          <Label>{t(`report.summary_stats.game_duration`)}</Label>
          {summaryReport.gameTimerLocal !== undefined &&
            summaryReport.gameTimerLocal !== "00:00:00" &&
            summaryReport.gameTimerLocal !== "0" ? (
            <Label>{summaryReport.gameTimerLocal}</Label>
          ) : (
            <Label>{summaryReport.gameTimerDB}</Label>
          )}
          <Label>{t(`report.summary_stats.game_id`)}{summaryReport.gameId}</Label>
        </ColumnContainer>
      </ColumnDiv>
      <ColumnDiv>
        <ColumnContainer style={{ display: "flex", width: "100%" }}>
          <Label>{t(`report.summary_stats.player_name`)}</Label>
          <Label>{summaryReport.playerFullName}</Label>
          <Label style={{ width: "40%", display: "flex" }}>{t(`report.summary_stats.player_email`)} {summaryReport.playersEmail}</Label>
        </ColumnContainer>
      </ColumnDiv>
      <ColumnDiv>
        <ColumnContainer style={{ display: "flex", width: "100%" }}>
          <Label>{t(`report.summary_stats.project_scope_completion`)}</Label>
          <Label>
            {t(`${summaryReport.projectScopeCompletionPercentage}% (${summaryReport.projectScopeCompletion || 0}/${summaryReport.howMatchTasks})`)}
          </Label>
          <Label>
            {t(`report.summary_stats.number_of_changes_to_plan`)}
          </Label>
          <Label>{summaryReport.ChangesInProjectArrangement || 0}</Label>
        </ColumnContainer>

      </ColumnDiv>

      <ColumnDiv>
        <ColumnContainer style={{ display: "flex", width: "100%" }}>
          <Label>{t(`report.summary_stats.position_at_game_end`)}</Label>
          {/* Label 2: Actual Position */}
          <Label>{summaryReport.positionAtGameEnd}</Label>
          {/* Label 3: Target Position */}
          {summaryReport.playerGrade[7][0].stepsMoreThenRelevant ? (
            <Label>
              {t(`report.summary_stats.targets.position.after`)} {summaryReport.positionAtGameEndTarget}
            </Label>
          ) : summaryReport.playerGrade[7][1].stepsLessThenRelevant > 0 ? (
            <Label>
              {t(`report.summary_stats.targets.position.before`)}{summaryReport.positionGoalLessThen}
            </Label>
          ) : (
            <Label>{t(`report.summary_stats.targets.na`)}</Label>
          )}

          {/* Label 4: Difference */}
          <Label>
            {t(`report.summary_stats.difference`)} {summaryReport.projectTargets.position.PositionDifference}
          </Label>
        </ColumnContainer>
      </ColumnDiv>
      <ColumnDiv>
        <ColumnContainer style={{ display: "flex", width: "100%" }}>
          {/* Category: Total Value */}
          <Label>{t(`report.summary_stats.total_value`)}</Label>

          {/* Label 1: Actual Value */}
          <Label className="p30">
            {summaryReport.totalValue}
          </Label>

          {/* Label 2: Target Value */}
          {summaryReport.playerGrade?.[7]?.[2]?.valueRelevant ? (
            <>
              <Label className="p30">
                {`${t(`report.summary_stats.targets.value`)} ${new Intl.NumberFormat('en-US').format(
                  summaryReport.totalValueTarget || 0
                )}`}
              </Label>
              <Label className="p30">
                {summaryReport.projectTargets?.value?.EarnedValueDifference !== "NA" ? (
                  `${t(`report.summary_stats.difference`)} ${summaryReport.projectTargets.value.EarnedValueDifference}`
                ) : (
                  `${t(`report.summary_stats.difference`)} ${t(`report.summary_stats.na`)}`
                )}
              </Label>
            </>
          ) : (
            <Label className="p30">{t(`report.summary_stats.targets.na`)}</Label>
          )}
          {/* 
          <Label className="p30">
            {summaryReport.projectTargets?.value?.EarnedValueDifference !== "NA" ? (
              `${t(`report.summary_stats.difference`)}: ${summaryReport.projectTargets.value.EarnedValueDifference}`
            ) : (
              `${t(`report.summary_stats.difference`)} ${t(`report.summary_stats.na`)}`
            )}
          </Label> */}
        </ColumnContainer>
      </ColumnDiv>

      <ColumnDiv>
        <ColumnContainer style={{ display: "flex", width: "100%" }}>
          {/* Label 1: Title */}
          <Label>{t(`report.summary_stats.total_budget_used`)}</Label>

          {/* Label 2: Actual Budget */}
          <Label>
            ${summaryReport.totalBudgetUsed}
          </Label>

          {/* Label 3: Target Budget */}
          {summaryReport.playerGrade[7][3].budgetRelevant ? (
            <Label >
              {t(`report.summary_stats.targets.budget.under`)} ${summaryReport.totalBudgetTarget.toLocaleString()}
            </Label>
          ) : (
            <Label>{t(`report.summary_stats.targets.na`)}</Label>
          )}

          {/* Label 4: Difference */}
          <Label style={{ display: "inline" }}>
            {t(`report.summary_stats.difference`)}
            {summaryReport.projectTargets.budget.BudgetDifference !== undefined && summaryReport.projectTargets.budget.BudgetDifference !== "NA"
              ? `$${summaryReport.projectTargets.budget.BudgetDifference}`
              : t(`report.summary_stats.na`)}
          </Label>
        </ColumnContainer>
      </ColumnDiv>
      <ColumnDiv>
        <ColumnContainer style={{ display: "flex", width: "100%" }}>
          <Label>{t(`report.summary_stats.total_remaining_budget`)}</Label>
          <Label>${summaryReport.totalRemainingBudget.toLocaleString()}</Label>
          {/* <Label>{report.summary_stats.gameId}{summaryReport.gameId}</Label> */}
        </ColumnContainer>
      </ColumnDiv>
      <ColumnDiv>
        <ColumnContainer style={{ display: "flex", width: "100%" }}>
          <Label>{t(`report.summary_stats.total_additional_budget`)}</Label>
          <Label>${summaryReport.totalAdditionalBudgetReceived.toLocaleString()}</Label>
          {/* <Label>{report.summary_stats.gameId}{summaryReport.gameId}</Label> */}
        </ColumnContainer>
      </ColumnDiv>

      <ColumnDiv>
        <ColumnContainer style={{ display: "flex", width: "100%" }}>
          <Label>{t(`report.summary_stats.total_value_of_resources_used`)}</Label>
          <Label>${Math.abs(summaryReport.totalValueOfResourcesUsed).toLocaleString()}</Label>
        </ColumnContainer>
      </ColumnDiv>
      <ColumnDiv>
        <ColumnContainer style={{ display: "flex", width: "100%" }}>
          <Label>{t(`report.summary_stats.remaining_resources`)}</Label>
          <Label style={{ width: "30%", display: "flex" }}>
            {summaryReport.remainResources.regular} {t(`global_variables.resources.standard`)}{" | "}
            {summaryReport.remainResources.senior} {t(`global_variables.resources.senior`)}{" | "}
            {summaryReport.remainResources.expensive} {t(`global_variables.resources.executive`)}
          </Label>
        </ColumnContainer>
      </ColumnDiv>
      <ColumnDiv>
        <ColumnContainer style={{ display: "flex", width: "100%" }}>
          <Label>{t(`report.summary_stats.number_of_resources_obtained_ad_hoc`)}</Label>
          <Label style={{ width: "30%", display: "flex" }}>
            {summaryReport.totalAdHocBought.adHocRegular} {t(`global_variables.resources.standard`)}{" | "}
            {summaryReport.totalAdHocBought.adHocSenior} {t(`global_variables.resources.senior`)}{" | "}
            {summaryReport.totalAdHocBought.adHocExpensive} {t(`global_variables.resources.executive`)}
          </Label>
        </ColumnContainer>
      </ColumnDiv>
      <ColumnDiv>
        <ColumnContainer style={{ display: "flex", width: "100%" }}>
          <Label>{t(`report.summary_stats.total_overpaid_for_resources`)}</Label>
          <Label>
            ${
              (summaryReport.totalAdHocBought.adHocRegular * 100) +
              (summaryReport.totalAdHocBought.adHocSenior * 200) +
              (summaryReport.totalAdHocBought.adHocExpensive * 500)
            }
          </Label>
        </ColumnContainer>
      </ColumnDiv>
      <ColumnDiv>
        <ColumnContainer style={{ display: "flex", width: "100%" }}>
          <Label>{t(`report.summary_stats.cards_taken_during_game`)}</Label>
          <Label style={{ display: "flex" }}>{t(`global_variables.tasks`)}: {`${summaryReport.cardsTaken.unplanned}`}</Label>
          <Label style={{ display: "flex" }}>{t(`global_variables.game_elements.constraints`)}: {`${summaryReport.cardsTaken.constraint}`}</Label>
          <Label style={{ display: "flex" }}>{t(`global_variables.game_elements.risks`)}: {`${summaryReport.cardsTaken.risk}`}</Label>
        </ColumnContainer>
      </ColumnDiv>
      <ColumnDiv>
        <ColumnContainer style={{ display: "flex", width: "100%" }}>
          {/* Label 1: Delays Taken */}
          <Label>{t(`report.summary_stats.delays_taken`)}</Label>

          {/* Label 2: Delay */}
          <Label>{`${summaryReport.cardsTaken.delay || 0}`}</Label>

          {/* Label 3: Value Deducted from Delay */}
          <Label>{t("report.summary_stats.value_deducted_from_delay")}</Label>

          {/* Label 4: Deducted Value */}
          <Label>{summaryReport.totalValueDeductedFromDelay || 0}</Label>
        </ColumnContainer>
      </ColumnDiv>
      <ColumnDiv>
        <ColumnContainer style={{ display: "flex", width: "100%" }}>
          {/* Label: Number of General PM Tasks */}
          <Label>{t(`report.summary_stats.number_of_general_pm_tasks`)}</Label>
          {/* Value: General PM Tasks Counter */}
          <Label style={{ display: "flex" }}>{summaryReport.generalPmTasksCounter || 0}</Label>
        </ColumnContainer>
      </ColumnDiv>

      <ColumnDiv>
        <ColumnContainer style={{ display: "flex", width: "100%" }}>
          {/* Label: Tasks Not Aligned With Goals */}
          <Label>
            {t(`report.summary_stats.number_of_tasks_not_aligned_with_goals`)}
          </Label>
          <Label style={{ display: "flex" }}>
            {summaryReport.alternativeNotAlignedWithGoalsCounter || 0}
          </Label>

          {/* Label: Tasks Completed at Gate */}
          <Label>
            {t(`report.summary_stats.number_of_tasks_completed_at_gate`)}
          </Label>
          <Label style={{ display: "flex" }}>
            {summaryReport.tasksExecutedAtGate || 0}
          </Label>
        </ColumnContainer>
      </ColumnDiv>

      <ColumnDiv>
        <ColumnContainer style={{ display: "flex", width: "100%" }}>
          {/* Gate Status Label */}
          <Label>{t(`report.summary_stats.gate.status`)}</Label>

          {/* Passed */}
          <Label style={{ display: "flex" }}>
            {`${t(`report.summary_stats.gate.passed`)} ${summaryReport.gateStatusCounter?.passed ?? 0
              }`}
          </Label>

          {/* Delayed */}
          <Label style={{ display: "flex", width: "15%" }}>
            {`${t(`report.summary_stats.gate.delayed`)} ${summaryReport.gateStatusCounter?.delayed ?? 0
              }`}
          </Label>
          {/* Returned */}
          <Label style={{ display: "flex", width: "15%" }}>
            {`${t(`report.summary_stats.gate.returned`)} ${summaryReport.gateStatusCounter?.returned ?? 0
              }`}
          </Label>
          {/* Canceled */}
          <Label style={{ display: "flex" }}>
            {`${t(`report.summary_stats.gate.canceled`)} ${summaryReport.gateStatusCounter?.canceled ?? 0
              }`}
          </Label>
        </ColumnContainer>
      </ColumnDiv>

      {/* Time Spent on Planning */}
      <ColumnDiv>
        <ColumnContainer style={{ display: "flex", width: "100%" }}>
          <Label>{t(`report.summary_stats.time_spent_on_planning`)}</Label>
          <Label>{summaryReport.totalTimeSpentOPlanning || 0}</Label>
          <Label>{t(`report.summary_stats.percentage_of_planning_from_game_duration`)}</Label>
          <Label>{summaryReport.percentOfPlanning || 0}</Label>
        </ColumnContainer>
      </ColumnDiv>
      {projectCanceled && (
        <ProjectCanceledStamp>
          {t(`report.summary_stats.project_canceled`)}
        </ProjectCanceledStamp>
      )}
      {playerQuit && (
        <ProjectCanceledStamp>
          {t(`report.summary_stats.player_quit`)}
        </ProjectCanceledStamp>
      )}
    </>
  );
}